import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgXTwitter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m5.093 6.163 14.673 19.679L5 41.837h3.325l12.924-14.008 10.444 14.008H43L27.505 21.054l13.74-14.89h-3.32L26.023 19.06 16.406 6.163zm4.889 2.452h5.196l22.939 30.764H32.92z" })
});
export default SvgXTwitter;
